module.exports = __webpack_public_path__ + "static/media/IMG_2563.d621f4e1.jpg";